export const HintId = {
  RightClickAdd: "rightClickAdd",
  MultiSelect: "multiSelect",
  FeedbackPaste: "feedbackPaste",
  FileExplorerUpload: "fileExplorerUpload",
  FileExplorerFolders: "fileExplorerFolders",
  TranslateAllOverwrites: "translateAllOverwrites",
} as const;

export type HintIdValue = (typeof HintId)[keyof typeof HintId];
